







































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WalletIcon extends Vue {
  @Prop({ default: '56' }) readonly width?: string;
  @Prop({ default: '56' }) readonly height?: string;
}
